const now = new Date()
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
const maxDate = new Date(today)

const calendarSettings = {
  max: maxDate,
  locale: 'de',
  startWeekday: 1,
  showDecadeNav: true,
  labelPrevDecade: 'Vorheriges Jahrzehnt',
  labelPrevYear: 'Vorheriges Jahr',
  labelPrevMonth: 'Vorheriger Monat',
  labelCurrentMonth: 'Aktueller Monat',
  labelNextMonth: 'Nächster Monat',
  labelNextYear: 'Nächstes Jahr',
  labelNextDecade: 'Nächstes Jahrzehnt',
  labelToday: 'Heute',
  labelSelected: 'Ausgewähltes Datum',
  labelNoDateSelected: 'Kein Geburtsdatum gewählt',
  labelCalendar: 'Kalender',
  labelNav: 'Kalendernavigation',
  labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren'
}

const locales = 'de-DE'

const formatterOptions = {
  dateFormatOptions: { year: 'numeric', month: '2-digit', day: '2-digit' },
  shortDateFormatOptions: { year: '2-digit', month: '2-digit', day: '2-digit' },
  currencyFormatOptions: { style: 'currency', currency: 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 2 },
  numberFormatOptions: { maximumFractionDigits: 2 },
  timeFormatOptions: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false },
  dateTimeFormatOptions: { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }
}
const formatter = {
  timeFormatter: new Intl.DateTimeFormat(locales, formatterOptions.timeFormatOptions),
  shortTimeFormatter: new Intl.DateTimeFormat(locales, { ...formatterOptions.timeFormatOptions, second: undefined }),
  dateFormatter: new Intl.DateTimeFormat(locales, formatterOptions.dateFormatOptions),
  dateTimeFormatter: new Intl.DateTimeFormat(locales, formatterOptions.dateTimeFormatOptions),
  shortDateFormatter: new Intl.DateTimeFormat(locales, formatterOptions.shortDateFormatOptions),
  dateShortTimeFormatter: new Intl.DateTimeFormat(locales, { ...formatterOptions.dateTimeFormatOptions, second: undefined }),
  currencyFormatter: Intl.NumberFormat(locales, formatterOptions.currencyFormatOptions),
  shortCurrencyFormatter: Intl.NumberFormat(locales, { ...formatterOptions.currencyFormatOptions, maximumFractionDigits: 0, minimumFractionDigits: 0 }),
  numberFormatter: Intl.NumberFormat(locales, formatterOptions.numberFormatOptions),
  formatterOptions
}
export {
  locales,
  calendarSettings,
  formatter
}

export default {
  locales,
  calendarSettings,
  formatter
}
